import { Group, Paper } from '@mantine/core';
import React from 'react';
import { VCycleSide } from '../../../resource/enumerations/VCycleSide';
import { VCycleEditorWingTableComponent } from './vcycle-editor/VCycleEditorWingTableComponent';

export const VCycleRepresentationEditorComponent = ({ workflowId }: { workflowId: string }) => {
    return (
        <Group grow align={'start'}>
            <Paper p={'xs'}>
                <VCycleEditorWingTableComponent workflowId={workflowId} side={VCycleSide.LEFT} />
            </Paper>
            <Paper p={'xs'}>
                <VCycleEditorWingTableComponent workflowId={workflowId} side={VCycleSide.RIGHT} />
            </Paper>
        </Group>
    );
};
